import { Link, useLocation } from 'react-router-dom';

interface HeaderLogoProps {
  logoUrl?: string;
  siteName: string;
  siteSubtitle: string;
}

export function HeaderLogo({ logoUrl, siteName, siteSubtitle }: HeaderLogoProps) {
  const location = useLocation();
  
  const handleLogoClick = (e: React.MouseEvent) => {
    // If already on home page, scroll to top
    if (location.pathname === '/') {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <Link
      to="/"
      className="flex flex-col items-center space-y-1 sm:flex-row sm:space-x-2 lg:space-x-4 transition-transform hover:scale-105"
      onClick={handleLogoClick}
    >
      {logoUrl ? (
        <img
          src={logoUrl}
          alt="Brasão Municipal"
          className="h-7 w-auto sm:h-10 md:h-12 lg:h-16 dark:brightness-110"
        />
      ) : (
        <div className="h-7 w-7 sm:h-10 sm:w-10 md:h-12 md:w-12 lg:h-16 lg:w-16 bg-gray-100 dark:bg-gray-800 rounded flex items-center justify-center">
          <span className="text-gray-400">Logo</span>
        </div>
      )}
      <div className="flex flex-col text-center sm:text-left">
        <span className="text-sm font-bold tracking-wider text-gray-900 dark:text-white sm:text-base md:text-xl lg:text-2xl" style={{ textTransform: 'uppercase' }}>
          {siteName}
        </span>
        <span className="text-[10px] font-semibold tracking-[0.05em] text-gray-700 dark:text-gray-200 sm:text-xs sm:tracking-[0.05em] lg:text-sm lg:tracking-[0.04em]" style={{ textTransform: 'uppercase' }}>
          {siteSubtitle}
        </span>
      </div>
    </Link>
  );
}